var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamilienrecht(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1339.9 1041.7",
    style: {
      enableBackground: "new 0 0 1339.9 1041.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4F4F4;}\n\t.st1{fill:#61656D;}\n\t.st2{opacity:0.2;enable-background:new    ;}\n\t.st3{fill:#137F7B;}\n\t.st4{fill:#B0B4B9;}\n\t.st5{fill:#84888F;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{opacity:0.9;fill:#FFFFFF;enable-background:new    ;}\n\t.st8{opacity:0.7;fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;enable-background:new    ;}\n\t.st9{fill:#DDDDDD;}\n\t.st10{fill:#DADDDF;}\n\t.st11{fill:#B1B5BA;}\n\t.st12{fill:#FC9D9D;}\n\t.st13{opacity:0.15;enable-background:new    ;}\n\t.st14{opacity:0.2;fill:none;stroke:#000000;stroke-width:1.17;stroke-miterlimit:10;enable-background:new    ;}\n\t.st15{fill:#21252B;}\n\t.st16{opacity:0.3;enable-background:new    ;}\n\t.st17{opacity:0.15;fill:none;stroke:#000000;stroke-width:0.45;stroke-miterlimit:10;enable-background:new    ;}\n\t\n\t\t.st18{opacity:0.15;fill:none;stroke:#000000;stroke-width:1.17;stroke-linecap:round;stroke-miterlimit:10;enable-background:new    ;}\n\t.st19{fill:#3F4249;}\n\t.st20{fill:#858990;}\n\t.st21{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n\t.st22{fill:none;stroke:#868A91;stroke-width:0.8;stroke-miterlimit:10;}\n\t.st23{opacity:0.4;}\n\t.st24{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n\t.st25{fill:#868A91;}\n\t.st26{opacity:0.3;}\n\t.st27{fill:#B2B6BB;}\n\t.st28{opacity:0.2;}\n\t.st29{opacity:0.5;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 664.3,
    cy: 964.8,
    rx: 612.1,
    ry: 40.9
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M828,654.8h-16.2l48.9,311.1h6.3L828,654.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M867,965.9h-2.7l-16.4-124l-5-2.9l-30.4-179.4l-0.7-4.8H828L867,965.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M850.3,732h170.4c4.1,0,7.9,1.6,10.8,4.5c2.9,2.9,4.5,6.7,4.5,10.8v3.1H835.1v-3.1c0-4,1.6-7.9,4.5-10.8 C842.4,733.6,846.3,732,850.3,732L850.3,732z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1060.2,550.9l-2.3-0.3c-3.8-0.5-7.2,2.1-7.8,5.8l-12.7,88.1c-0.5,3.8,2.1,7.2,5.8,7.8l2.3,0.3 c3.8,0.5,7.2-2.1,7.8-5.8l12.7-88.1C1066.6,554.9,1064,551.5,1060.2,550.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1017.1,754.6h-10.6l31.9,210.2h4.1L1017.1,754.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1042.5,964.8h-1.7l-10.7-88l-3.3-1.9l-19.9-117.2l-0.5-3.1h10.6L1042.5,964.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M870.9,754.6h10.6l-31.9,210.2h-4.1L870.9,754.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M850,964.8h-1.7l10.8-88l-3.3-1.9l15.4-117.2l-0.5-3.1h10.6L850,964.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1039.6,750.4H835.3c-1.8,0-3.3,1.5-3.3,3.3v1.1c0,1.8,1.5,3.3,3.3,3.3h204.3c1.8,0,3.3-1.5,3.3-3.3v-1.1 C1042.9,751.9,1041.4,750.4,1039.6,750.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1036.6,753.7l29.5-199.2c0.1-0.5,0.2-1,0.5-1.4c0.3-0.4,0.6-0.8,1-1.1c0.4-0.3,0.9-0.5,1.4-0.6 c0.5-0.1,1-0.1,1.5-0.1h0.2c1,0.2,1.9,0.7,2.5,1.5c0.6,0.8,0.8,1.8,0.7,2.8l-29.6,199.2c-0.1,0.9-0.6,1.7-1.3,2.3 c-0.7,0.6-1.6,0.9-2.5,0.9l0,0c-0.6,0-1.1-0.1-1.6-0.3s-0.9-0.6-1.3-1c-0.4-0.4-0.6-0.9-0.8-1.4S1036.5,754.3,1036.6,753.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M982.3,758.2l31.9,207h4.1l-25.4-207H982.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M845.4,758.2l-25.4,207h4.1l31.9-207H845.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1018.3,965.2h-1.8l-27.4-200.7c-0.1-0.8-0.4-1.5-1-2c-0.6-0.5-1.3-0.8-2.1-0.9l-3.5-0.4l-0.4-3.1h10.6 L1018.3,965.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M822.6,965.2l28.5-200.4c0.1-0.8-0.1-1.6-0.6-2.2c-0.5-0.7-1.2-1.1-2-1.3l-3.4-0.6l0.3-2.4H856l-31.8,207 L822.6,965.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1034.8,746.2H835.5v3.8h199.4V746.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1060.9,550.7l-15.3,102.2l6.1-3.3l13.8-95.1L1060.9,550.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M880.1,233.3c0-15-5.5-29.5-15.5-40.6c-10-11.2-23.8-18.3-38.7-19.9v-0.4h-6.7c-15.8,0.6-30.7,7.2-41.7,18.6 c-11,11.4-17.1,26.5-17.1,42.3c0,15.8,6.1,31,17.1,42.3c11,11.4,25.9,18,41.7,18.6l6.7-0.4c14.9-1.6,28.7-8.7,38.7-19.9 C874.5,262.7,880.1,248.3,880.1,233.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M874.4,243.1c5.4-33.2-17.2-64.5-50.4-69.9c-33.2-5.4-64.5,17.2-69.9,50.4c-5.4,33.2,17.2,64.5,50.4,69.9 C837.7,298.9,869,276.3,874.4,243.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M814.2,287.5c30,0,54.2-24.3,54.2-54.2c0-30-24.3-54.2-54.2-54.2c-30,0-54.2,24.3-54.2,54.2 C760,263.2,784.2,287.5,814.2,287.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M814.2,287.5c30,0,54.2-24.3,54.2-54.2c0-30-24.3-54.2-54.2-54.2c-30,0-54.2,24.3-54.2,54.2 C760,263.2,784.2,287.5,814.2,287.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M814.2,287.5c30,0,54.2-24.3,54.2-54.2c0-30-24.3-54.2-54.2-54.2c-30,0-54.2,24.3-54.2,54.2 C760,263.2,784.2,287.5,814.2,287.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M814.2,179c1,0,2,0,3,0.1c-13.8,0.8-26.9,6.8-36.4,16.8c-9.5,10.1-14.8,23.4-14.8,37.2s5.3,27.2,14.8,37.2 c9.5,10.1,22.6,16.1,36.4,16.8c-0.9,0-1.9,0.1-3,0.1c-14.4,0-28.2-5.7-38.3-15.9c-10.2-10.2-15.9-24-15.9-38.3s5.7-28.2,15.9-38.3 C786,184.7,799.8,179,814.2,179L814.2,179z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M815.7,237.7l-1.5-40c0-0.4,0-0.8,0.1-1.1c0.1-0.4,0.3-0.7,0.6-1c0.2-0.3,0.6-0.5,0.9-0.7 c0.3-0.2,0.7-0.3,1.1-0.3c0.4,0,0.8,0,1.1,0.2c0.4,0.1,0.7,0.3,1,0.6c0.3,0.3,0.5,0.6,0.6,0.9c0.2,0.3,0.2,0.7,0.2,1.1l1.3,34.5 l22.9-0.6c0.4,0,0.7,0.1,1.1,0.2c0.3,0.1,0.7,0.3,0.9,0.6c0.3,0.3,0.5,0.6,0.6,0.9c0.1,0.3,0.2,0.7,0.2,1.1c0,0.4-0.1,0.7-0.2,1.1 c-0.1,0.3-0.3,0.7-0.6,0.9c-0.3,0.3-0.6,0.5-0.9,0.6c-0.3,0.1-0.7,0.2-1.1,0.2L815.7,237.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M783.3,193.4l78.7,65.4c0,0,2.1-4.4,2.7-5.8c0.5-1.2,1.7-5,1.7-5L819,179.1C819,179.1,801.6,176.9,783.3,193.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M772.2,258.8l55.4,27c-4,1.3-8.2,1.8-12.4,1.4C803.1,286.4,784.7,280.4,772.2,258.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M422.6,250.6H321.1V391h101.5V250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M409.1,263.6h-74.4v114.4h74.4V263.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M425.6,250.6h-3V391h3V250.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M394,283.5h-34.8v74.8H394V283.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M348.4,337.9h20.3v-20.3h-20.3V337.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M934.1,601.5c-0.7,3-2.1,5.7-4.1,8c-2,2.3-4.6,3.9-7.5,4.9l-71.7,13.1l0.1,0.1l-31.4,2.8l-3,1.4 c-2.5,1.2-5.3,1.9-8,1.9c-2.8,0.1-5.6-0.4-8.1-1.5h-0.1l-4.4-1.8c-0.5-0.2-1.1-0.3-1.7-0.3c-0.6,0-1.2,0.1-1.7,0.4l-10.8,5.2 c-0.3,0.1-0.6,0.2-0.9,0.2c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.3,0-0.5,0.1-0.8 c0.1-0.3,0.3-0.5,0.5-0.7l7.8-6.6l-11.7,9.6c-0.3,0.2-0.6,0.4-0.9,0.4c-0.3,0.1-0.7,0-1-0.1c-0.3-0.1-0.6-0.3-0.8-0.5 c-0.2-0.2-0.4-0.5-0.5-0.8c-0.1-0.3-0.1-0.6,0-1c0.1-0.3,0.2-0.6,0.4-0.9l8.2-9.1l-10.8,11.9c-0.3,0.3-0.6,0.5-1,0.6 c-0.4,0.1-0.8,0.1-1.2-0.1c-0.3-0.1-0.6-0.3-0.9-0.5c-0.2-0.2-0.4-0.5-0.5-0.9c-0.1-0.3-0.1-0.7-0.1-1c0-0.3,0.2-0.7,0.4-0.9 l8-10.7l-12.5,10.5c-0.2,0.2-0.5,0.3-0.7,0.4c-0.3,0.1-0.5,0.1-0.8,0.1c-0.3,0-0.6-0.1-0.8-0.2c-0.3-0.1-0.5-0.3-0.7-0.5 c-0.5-0.4-0.6-1.8,0.2-2.6l13.2-13.2c1.3-1.4,3.1-2.3,5.1-2.5l22.6,0.6l23.2-3.1l-0.1-0.1l79.8-24.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M779.9,633c0.1,0,0.1,0,0.2-0.2l7.2-6.1c0.1-0.1,0.2-0.4,0.1-0.5s-0.4-0.2-0.5-0.1l-7.2,6.1 c-0.1,0.1-0.2,0.4-0.1,0.5L779.9,633z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M773.5,633.1c0.1,0,0.3,0,0.3-0.1l7.7-8.6c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.2-0.1-0.3 c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.1-0.3,0.1l-7.7,8.6c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0.1,0.3 C773.2,633.2,773.3,633.2,773.5,633.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M790.1,629.1c-2.4,1.5-6.6,3.8-7.9,4.8c-2,1.3-2.8-0.2-2.8-0.2c0,0.3,0,0.7,0.1,1c0.1,0.3,0.3,0.6,0.6,0.8 c0.3,0.2,0.5,0.2,0.8,0.3c0.3,0,0.6,0,0.9-0.1l10.8-5.2c0.5-0.2,1.1-0.4,1.7-0.4c0.6,0,1.2,0.1,1.7,0.3l-2.3-1.2 c-0.6-0.3-1.2-0.5-1.8-0.5C791.3,628.6,790.6,628.8,790.1,629.1L790.1,629.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M917.9,615.2l-74.1,12.7l-9.5,0.6l-14.8,1.9c-9.3,5.4-16.9,2.6-16.9,2.6c3.9-0.1,7.7-1.4,10.9-3.7 c1.4-1,3-1.7,4.7-2l21.5-3.8l62.9-19.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M957.5,500.3l-63.6,81.5l-17.4,8.9l19.1,31.8l15-12.1l14.7-13.4L957.5,500.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M895.7,584.8l12.7,19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M956.4,501.4l-51.5,97.4l-17.4,8.9l8.2,14.6l15-12.1l14.7-13.4L956.4,501.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M847.6,944.2l-0.2,7.4c-0.1,2.7-1.2,5.2-3.1,7.1c-1.9,1.9-4.4,3-7.1,3.1h-0.1l-19.3,0.3h-54.2 c-0.9-1.6-3.4-6.5-0.3-7.6l36.9-15.8c6.5-2.2,9.1-5.2,12.5-8.6c1.3-1.8,1.8-4.1,1.5-6.3l-2.5-17.5l31.2-20.2l3.1,46L847.6,944.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M778.4,961.5c-3.9-4.3-5.4-7.3-6-10.6c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.3-0.3,0.5-0.4l25.5-10.9 c0.3-0.1,0.6-0.2,0.9-0.1c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.6c0.2,0.2,0.4,0.5,0.4,0.8c1.3,4.3,2.9,14.2,9.2,20.8 l36.3-0.1c0.6,0,1.2,0.3,1.6,0.7c0.4,0.4,0.6,1,0.6,1.6c0,0.6-0.2,1.2-0.6,1.6c-0.4,0.4-1,0.7-1.6,0.7l-89.8,0.1 c-0.6,0-1.2-0.2-1.7-0.7c-0.4-0.4-0.7-1-0.7-1.7v-2.2L778.4,961.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M807.7,962.1h10.1l19.3-0.3h0.1c2.7-0.1,5.2-1.2,7.1-3.1c1.9-1.9,3-4.4,3.1-7.1l0.2-7.4L846,932l-3.1-46 l-11.2,7.4l4.2,48.8c0,0,3.7,11.5-28.1,15.5L807.7,962.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M831.9,762.9l13.4,144.2l-33.7,5.4L794.4,825L831.9,762.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M834.2,909l-12.2-105.8l10-40.3l13.4,144.2L834.2,909z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M959.3,496.7c0,0-6.6,14.6-10.5,23.9l58-36l-29.4-10.2l-16.2,5.7L959.3,496.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M753.9,962.1h-54.2c-0.9-1.6-3.4-6.5-0.3-7.6l36.9-15.8c6.5-2.2,13.3-3.7,17.1-8.6c0.8-1.1,1.4-2.2,1.9-3.4 l9.9-65.2l32.3,17.1l-5.9,27.4c-1.4,10.1-4.2,20.1-6.9,30.1c-0.6,2.7-1,5.4-1,8.2l-0.2,7.4c-0.1,2.7-1.2,5.2-3.1,7.1 c-1.9,1.9-4.4,3-7.1,3.1h-0.2L753.9,962.1L753.9,962.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M698.7,959.7c0.5,1,0.9,1.9,1.2,2.5h54.2l19.4-0.3h0.1c2.7-0.1,5.2-1.2,7.1-3.1c1.9-1.9,3-4.5,3.1-7.1 l0.2-7.4c0-3.2,0.5-6.3,1.4-9.4c1.7-5.1,2.5-10.1,3.7-15.3l3.1-14.9l-1.3,2.3l-10.6-0.9l-9.4,38c0,0-9.9,13.5-39.6,14.7l-29.6,1 L698.7,959.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M715.3,961.5c-3.1-3.4-5.2-7.6-6.1-12.1c0-0.2,0-0.4,0.1-0.6c0.1-0.2,0.3-0.3,0.5-0.4l23.9-8.6 c0.3-0.1,0.6-0.2,0.9-0.1c0.3,0,0.6,0.1,0.9,0.2c0.3,0.1,0.5,0.3,0.7,0.6c0.2,0.2,0.4,0.5,0.4,0.8c1.3,4.3,4.5,13.5,10.8,20 l36.3-0.1c0.3,0,0.6,0,0.9,0.1s0.6,0.3,0.8,0.5c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.3,0.2,0.6,0.2,0.9c0,0.3-0.1,0.6-0.2,0.9 c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.8,0.5s-0.6,0.1-0.9,0.1l-89.7,0.1c-0.6,0-1.2-0.2-1.7-0.7c-0.4-0.4-0.7-1-0.7-1.7 v-2.2L715.3,961.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1034.4,677.9c0,0,3.8,37.5-31.9,53.6c-7,3.1-14.4,4.9-22,5.4l-145.9,10.8c0,0-4.1,29.9-17,69.1 c-8,24.3-15.2,48.3-20.2,72.6l-4.8,20.4l-35.1-6.2l17.5-183.3c0.6-4.3,2.4-8.2,5.3-11.4c2.9-3.2,6.7-5.4,10.9-6.3L962,665.6 l49.5-2.3L1034.4,677.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M980.5,736.9c7.6-0.5,15-2.4,22-5.4c35.6-16.1,31.9-53.6,31.9-53.6l-4-6.1l-10.2,2.1c0,0-7.6,39.9-41.9,45.4 L821,735.7c0,0,2.5,20.2-14.8,72.4c-4.9,14.8-9.1,29.9-12.7,45.1l-13,55l12.1,1.7l5-20.4c5-24.3,12.2-48.3,20.2-72.6 c12.8-39.2,17-69.1,17-69.1L980.5,736.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M946.1,524.1c9-12.4,19-24,29.8-34.7l31-18.2c0,0,30.4,30.4,31.2,59.2c0,0,0.8,21.8-5.5,51.4 c0,0-5.6,29.5-1.5,53.8c0.6,3.7,1.2,7.4,1.7,11.2l4.1,31.1c0,0.2,0,0.3,0,0.5c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.5,0.2 c-0.2,0-0.3,0-0.5-0.1c-4.1-2.1-13-5.9-41.1-5.9c-2.3,0-25.7,0.8-39.7-2.3c0,0-26.4-55.3-24.1-74.8 C935.5,552.6,946.1,524.1,946.1,524.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M956.5,545.3c0,0,4.7,22-9.7,34.1c0,0,10.7,27.7,9.5,41.8l-5.9,10.6l-18.2-56.6L956.5,545.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M916.2,585l-0.2,8.8l10.1-1.6l14-7.6l-0.9-8.4L916.2,585z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M915.4,589.8c0,0,10.8-5.3,10-6.9l-9.2,2.9L915.4,589.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.7,397.6c0,0-7.8,13.2,7.8,26.5l6.1-24L920.7,397.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M961.9,480.1l-0.5,1.8l-0.2-1.8l-1.9,16.6l2-12c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0 c0,0,0.1,0.1,0.1,0.1l1.1,13.3l11.2-6.8l1.1-9.3L961.9,480.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M968.1,672.9l-5.7-16.8l-15.8-3.6c4.4,10.5,8,18.1,8,18.1c14,3.1,37.4,2.3,39.7,2.3c5.3,0,9.9,0.1,14,0.4 C986.9,672.9,968.1,672.9,968.1,672.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M928.7,401.6c0,0-2,13-1.3,19.1l1.6,8.9l-3,12.5c-0.1,0.5-0.1,1.1,0.2,1.6c0.2,0.5,0.6,0.9,1.1,1.2l3.6,0.3 l8.8,14.3c2.7,5.1,5.9,6.1,11.4,4.2l8-3.5c0.6-0.2,1.2-0.1,1.7,0.1c0.5,0.2,1,0.7,1.2,1.2l2.3,18.6l39-14l-5.1-24 c0,0-4.6-53.1-36.2-57.8C946.5,382,928.7,401.6,928.7,401.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.5,427.1c-0.4-1.4,0.1-2.8,1.3-3.2c1.2-0.3,2.4,0.4,2.8,1.7c0.5,1.3-0.1,2.8-1.3,3.2c-0.3,0.1-0.6,0.1-0.9,0 c-0.3,0-0.6-0.1-0.9-0.3c-0.3-0.2-0.5-0.4-0.7-0.6C931.7,427.6,931.6,427.4,931.5,427.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M931.8,426.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.2 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.1-0.1,0.2-0.1,0.3c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.2-0.2 C931.8,426.4,931.8,426.3,931.8,426.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M962,462.1l0.8,2.4l7.4-7.5c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.5s-0.3-0.2-0.5-0.3 c-0.2,0-0.4,0-0.5,0.1l-10.9,4.5c0.5-0.2,1-0.3,1.5-0.2c0.5,0.1,1,0.4,1.3,0.8C961.4,461.4,961.7,461.8,962,462.1L962,462.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M934.6,450.4c2.1-1.1,3.9-2.5,5.5-4.3c0,1.4-0.3,2.9-1,4.2c-0.7,1.3-1.6,2.4-2.8,3.3L934.6,450.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.6,419.5c0.2,0.3,1.6-0.2,3.4-0.4s3.2-0.1,3.4-0.4c0.1-0.2-0.2-0.4-0.8-0.6c-0.9-0.2-1.7-0.3-2.6-0.2 c-0.9,0.1-1.8,0.4-2.6,0.8C928.8,419.1,928.5,419.4,928.6,419.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1006.8,471.2l-2.7-9.6l-44.8,16.6v18.5l1.8-14.1c0.2-0.9,1-1.1,1-0.2c0.3,4.7,1.1,9.3,2.3,13.9L1006.8,471.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M900.3,554.6l0.8,3.5c0.3,1.1,0.7,2.2,1.4,3.2c0.4,0.6,0.6,1.2,0.7,2c0.1,0.7,0,1.4-0.3,2l-2.6,3.9 c0,0-2.2,3.5,3,4.3c0.8,3,1.7,5.9,2.7,8.8c0.5,1.2,1.2,2.2,2.2,2.9c1,0.7,2.2,1.2,3.4,1.3c3.1,0.2,8.2-2.1,13.8-3.6l14-3.9 l-5.5-42.5l-33.9,6.7L900.3,554.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.4,403.6c0,0,5,14.7,17,8.6c0,0,6.8-4.3,10.9,5.8c0,0,2.5,6,6.4,3.7l6.3,5.3c0,0,5.2,5.8,6.8,18.4 c0.8,6.8,0.3,13.7-1.4,20.2c-2.5,9.8-6.2,29.3,5.2,27.3c1.7-0.3,3.3-1,4.7-2.1c4.8-3.5,21.6-13.9,36.5,2.2c0,0,15.2,13.6,16,44 c0,0,10.1,10.8,9.5-33.2c-0.1-8-2-15.9-5.7-23.1c-3.1-6.1-7.7-11.3-13.2-15.3c-5.3-3.7-10-8.2-14-13.4 c-5.9-7.9-12.5-18.8-10.6-26.8c0.5-1.9,0.9-3.9,1.1-5.9c0.8-9.1,0.7-30.3-16.4-43.8c-8.3-6.4-18.6-9.6-29.1-9.1 c-13,0.5-35.4,12.4-37.7,31.1L928.4,403.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M966.4,428.8l3.4-1.9l1.6,4.1L966.4,428.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M965.7,429.2l-4.9-8c-1.2-1.8-1.6-4-1.2-6.1c1.5-7.3,11.8-8.5,13.6,0.8c2.1,11-7.2,12.9-7.2,12.9L965.7,429.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M963.9,419.3c0,0.2,0.2,0.4,0.4,0.6c0.2,0.1,0.4,0.2,0.7,0.2c0.2-0.1,0.4-0.2,0.5-0.4 c0.1-0.2,0.2-0.4,0.1-0.6c-0.2-1-0.3-2-0.3-3c0-0.7,0.3-1.4,0.8-2c0.5-0.4,1.1-0.4,2-0.2c0.1,0,0.2,0.1,0.3,0s0.2-0.1,0.2-0.2 c0.1,0,0.2-0.2,0.3-0.5c0-0.2,0-0.4-0.1-0.6c-0.1-0.2-0.3-0.3-0.5-0.4c-0.5-0.2-1.1-0.2-1.7-0.1c-0.5,0.1-1.1,0.3-1.5,0.6 c-0.4,0.4-0.8,0.9-1,1.4c-0.2,0.5-0.4,1.1-0.4,1.7C963.5,417,963.6,418.2,963.9,419.3L963.9,419.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M872.4,769.9c-3.2-0.3-7.8-2.6-10.1-3.1c-2.2-0.5-4.4-0.7-6.6-0.4c-16.8-0.4-12.5-5.5-12.5-5.5l20.3-7 c-3.1-63.9,3.9-69.3,3.9-69.3l45-23.6l39.4-1.5c0,0,8.3,22.8-20.1,30.2c0,0-12.8,7.4-39.3,13.6c0,0-1.8,24.8-10.9,47.5 c-0.9,2.2-1.5,4.1-0.8,5.9c0.4,0.9,0.6,1.9,0.7,2.9C881.5,763.3,882.7,770.8,872.4,769.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M951.8,659.4l-43.3,1.5l-38.7,18.9c-2,1.3-3.5,3.4-4.2,5.7c-1.3,4.4-2.9,17.2-3.3,34.8l27.6,4.5 c2.2-11.1,3.4-20.8,3.4-20.8c26.1-8.2,39.3-13.6,39.3-13.6C960.8,683,951.8,659.4,951.8,659.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M951.8,659.4l-8,0.3c0.8,2.5,5.4,14-16.7,21.7L888,699.2l-3.7,24.8l5.4,0.9c2.2-11.1,3.4-20.8,3.4-20.8 c26.1-7.4,39.3-13.6,39.3-13.6C960.8,683,951.8,659.4,951.8,659.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M889.1,724.6l-4.8-0.6l-8,28.7c-0.5,1.7-0.5,3.4,0,5.1c0,0,3.8,14.6-13,9.2c2.5,0.8,6.3,2.6,9.1,2.8 c10.2,0.9,9.1-6.6,8.8-10.3c-0.1-1-0.3-2-0.7-2.9c-0.7-1.8-0.1-3.7,0.8-5.9C884.7,742.3,887.3,733.6,889.1,724.6L889.1,724.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M991.6,506.8c0,0-15.8,3.4-20,25.8l-13,83.4l6.6-5L991.6,506.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.5,569.8c2.9,13,5.4,7.9,5.4,7.9c1.8-2,3.6-4,5.2-5.6c5.1-5.1,8.4-11.8,9.4-19c2.8-22.2-17.5-27.8-17.5-27.8 c-25.9-7.5-39.9,14.4-39.9,14.4c-8.9,8.5,2.2,16.6,2.2,16.6c-0.8-1.9-1.2-3.9-1.1-5.9c0.1-2,0.6-4,1.6-5.8c0,0,0,8.8,9.6,9.6 c-1.7-0.6-3.2-1.6-4.3-2.9c-1.2-1.3-2-2.9-2.4-4.6c0,0,2.3,6.7,16.9,7.9c0,0-6.4-4.2-8.5-8.3c1.7,2.1,3.8,3.9,6.2,5.2 c2.4,1.3,5,2.1,7.7,2.3c-3.6-2.7-6.3-6.5-7.7-10.8c0,0-1.5,4.5,15.2,15.4L936.5,569.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1004,506c0,0,29.2,3.4,15.8,52.3l-29,99.5l-10.9-7.4L1004,506z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M932.7,566.3l2.6-0.3l0.7,2.9L932.7,566.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M932.1,566.4l-1-6.2c-0.3-1.4,0-2.9,0.8-4.1c2.7-4.1,9.4-2.3,8.2,3.9c-1.4,7.3-7.7,6.2-7.7,6.2L932.1,566.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M933.5,559.8c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0.1,0.2s0.1,0.1,0.2,0.2c0.1,0,0.1,0.1,0.2,0.1 c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.2-0.2c0-0.1,0.1-0.1,0.1-0.2c0.1-0.7,0.3-1.3,0.6-1.9c0.2-0.4,0.6-0.8,1-1 c0.4-0.1,0.8,0,1.3,0.4c0,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.1-0.1-0.3-0.2-0.4c-0.3-0.2-0.6-0.4-1-0.5c-0.4-0.1-0.7-0.1-1.1,0c-0.4,0.1-0.7,0.3-1,0.6c-0.3,0.3-0.5,0.6-0.7,1 C933.8,558.3,933.6,559,933.5,559.8L933.5,559.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.9,562.8c-0.2-0.4-0.2-0.9,0-1.3c0.2-0.4,0.5-0.7,0.9-0.9c0.7-0.3,1.6,0.3,2,1.2c0.2,0.4,0.2,0.9,0,1.3 c-0.2,0.4-0.5,0.7-0.9,0.9c-0.2,0.1-0.4,0.1-0.6,0c-0.2,0-0.4-0.1-0.6-0.2c-0.2-0.1-0.3-0.3-0.5-0.4S905,563.1,904.9,562.8 L904.9,562.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M905.1,562.2c0-0.1,0-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2 c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.2-0.1S905.1,562.3,905.1,562.2L905.1,562.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.9,557.7c0.2,0.2,1.3-0.2,2.7-0.4c1.4-0.2,2.6-0.2,2.7-0.5c0-0.1-0.2-0.3-0.7-0.4c-0.7-0.1-1.4-0.1-2.1,0 c-0.7,0.1-1.4,0.4-2,0.7C903,557.3,902.8,557.6,902.9,557.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M940.6,581c0,0-12.1,9-24.6,11.3l-0.6,0.4c-5.3,3.7-8,8.2-10.9,15.4c-3.7,9.3-9.1,43.1-7.3,52 c1.5,7.8,55.3,0.8,55.3,0.8S957.4,594.6,940.6,581z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M952.7,660.8l0.8-12.9l-10.9,4.3l-3.1,10.3L952.7,660.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M946.1,599.7h1.1l4.5,14.5l1.2,10.6L946.1,599.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M922.8,607.7c-0.2,0-0.4,0-0.5,0.1c-0.2,0.1-0.3,0.2-0.4,0.3s-0.2,0.3-0.2,0.5c0,0.2,0,0.4,0,0.5l9.5,33.6 l7.1-3.9L922.8,607.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M985.4,648.4c0,0-32.6,12-87.3,26.5l-9.3-9.3l65-35.8l14.4-16.4L985.4,648.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M904.3,673.3L902,675c-1.9,1.5-4.1,2.5-6.4,3.1c-2.3,0.6-4.8,0.7-7.1,0.2h-0.1l-0.2,0c-1-0.2-2.1-0.7-2.9-0.1 l-8.1,6.4c-0.2,0.2-0.5,0.3-0.7,0.3c-0.3,0-0.5,0-0.8-0.1c-0.2-0.1-0.4-0.2-0.6-0.4s-0.3-0.4-0.3-0.6c-0.1-0.2-0.1-0.5,0-0.7 c0-0.2,0.1-0.5,0.3-0.6l5.4-7l-8.1,10.2c-0.2,0.2-0.4,0.4-0.7,0.5c-0.3,0.1-0.6,0.2-0.9,0.1c-0.3,0-0.6-0.1-0.8-0.3 c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1-0.3-0.2-0.5-0.2-0.8c0-0.3,0.1-0.6,0.2-0.8l5.2-9.2l-6.9,12c-0.2,0.3-0.4,0.5-0.7,0.7 c-0.3,0.1-0.7,0.2-1,0.2c-0.3,0-0.6-0.1-0.8-0.3c-0.3-0.2-0.5-0.4-0.6-0.6c-0.2-0.3-0.2-0.5-0.3-0.8c0-0.3,0-0.6,0.2-0.9l4.8-10.5 l-8.7,11.1c-0.1,0.2-0.3,0.4-0.5,0.5c-0.2,0.1-0.4,0.2-0.7,0.2c-0.2,0-0.5,0-0.7,0c-0.2-0.1-0.5-0.2-0.6-0.3 c-0.3-0.3-0.5-0.7-0.6-1.1c-0.1-0.4,0.1-0.8,0.3-1.2l8.7-13.5c0.8-1.5,2.2-2.5,3.8-3.1l22.5-3.8L904.3,673.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M875.3,683c0.1,0,0.1,0,0.2-0.2l5-6.4c0.1-0.1,0.1-0.4,0-0.5s-0.4-0.1-0.5,0l-5,6.4c-0.1,0.1-0.1,0.4,0,0.5 L875.3,683z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M869.9,684.3c0.1,0,0.2-0.1,0.2-0.2l4.9-8.6c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.2,0-0.2,0 c-0.1,0-0.1,0.1-0.2,0.1l-4.9,8.6c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.1,0.2C869.7,684.3,869.8,684.3,869.9,684.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M883.2,677.9c-1.8,1.7-4.8,4.4-5.8,5.5c-1.5,1.5-2.4,0.3-2.4,0.3c0,0.3,0.1,0.6,0.3,0.8 c0.2,0.2,0.4,0.4,0.7,0.5c0.2,0.1,0.5,0.1,0.8,0.1c0.3,0,0.5-0.1,0.7-0.3l8.1-6.4c0.8-0.6,1.9-0.1,2.8,0.1l-2.2-1.3 c-0.5-0.2-1.1-0.2-1.6-0.1C884.2,677.2,883.6,677.5,883.2,677.9L883.2,677.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M975.2,646.5l-72.6,25.4c0,0-4.4,5.8-14.2,6.8c0,0,8,1.7,15.9-5.3l45.5-13.1l30.1-9.8L975.2,646.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1014.6,550.6c4.5-15.7,4-26,1.8-32.8c-1.4-4.3-4.3-7.8-8.2-10.1c-3.9-2.2-8.4-3-12.8-2.1 c-6.2,1.4-11.7,5.1-15.3,10.3c-3.1,4.3-5.1,9.3-5.9,14.6L960.8,613l-10.1,13.2l6.2,7l13.2-10.9l-6.2,16.4l23.5,16.3l8.4-30.4 L1014.6,550.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M922.8,607.7l11.5,26.8l-9.2,25.9l12.5,7.8l10.6-17.2c2.8-5.2,5-10.6,6.6-16.2l0.2-0.7 c0.4-1.3,0.3-2.6-0.2-3.9l-8.6-30.6L922.8,607.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M921.3,660.6l-6.6,1.6c0,0-0.7,3,4.1,2.5l3.9,0.2c1.1-1.5,1.9-3.2,2.5-5c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1,0-0.2,0L921.3,660.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M923.9,662.4l-1.9,4.5l-1.5,4.2c-0.1,0.3-0.2,0.7-0.1,1c0.1,0.3,0.2,0.7,0.4,0.9c0.4,0.5,1.1,0.7,2.1-0.4 l3.2-4.9l-3.4,7.3c0,0-0.6,1.8,1,1.9c0.3,0,0.7-0.1,1-0.2c0.3-0.1,0.6-0.4,0.8-0.6l0.2-0.3c0,0,0.5,3.1,2.8,1.3l2.2-2.3l-1,2 c0,0-0.8,2.5,1.9,1.3l3.7-3.8c0,0,1.6-2.8,2.6-5c0.2-0.5,0.3-1.1,0.3-1.7c0-0.6-0.2-1.2-0.6-1.7c-1.3-2.1-3.2-3.8-5.4-4.8 c-2.2-1.1-4.7-1.5-7.1-1.3L923.9,662.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M914.8,663.1c0.2,0.8,1,2,4.1,1.7l3.9,0.2l0.7-1.8C915.5,665,914.8,663.1,914.8,663.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M926.4,667.3l1.2-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M926.2,675l2.7-3.7l2.7-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M930.5,674.8l1.8-2.3l1-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M929.7,638.2l-32.1,21.5v1.3l33.2-19.3L929.7,638.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1036.8,677.9l-4.1-31.1c-0.5-3.8-1.1-7.5-1.7-11.2c-2.8-16.8-1-36.1,0.4-46.4c-1.4,8.6-2.8,16.9-4,23.8 c-1.6,9.7-1.2,18.3-1.8,28.1c-0.7,11.1-2.5,22.1-5.4,32.8l1.3,0.8c7.8,1.3,11.6,3,13.9,4.2c0.2,0.1,0.3,0.1,0.5,0.1 c0.2,0,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.3,0.3-0.4C1036.8,678.2,1036.8,678,1036.8,677.9L1036.8,677.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M964.1,613.3l27.5,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M808.4,633.6l-18.6,4l-0.1-0.1c-0.3-0.4-0.6-0.9-0.7-1.4s-0.1-1,0.1-1.5c0.1-0.5,0.4-1,0.8-1.3 c0.4-0.4,0.8-0.6,1.3-0.8l13.1-4L808.4,633.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M807.2,632.2l-18.2,4.1l0.8,1.4l18.6-4L807.2,632.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M907.1,620c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S906.4,620,907.1,620z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M918.8,611.8c0.6,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2S918.1,611.8,918.8,611.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M945.8,613c0.7,0,1.2-0.5,1.2-1.2c0-0.6-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.5-1.2,1.2 C944.6,612.4,945.2,613,945.8,613z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M939.9,630.6c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.5-1.2,1.2S939.3,630.6,939.9,630.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M945.8,643.5c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.5-1.2,1.2S945.2,643.5,945.8,643.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M934.1,650.5c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.5-1.2,1.2S933.4,650.5,934.1,650.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M934.1,602.4c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2c-0.6,0-1.2,0.5-1.2,1.2S933.4,602.4,934.1,602.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M914.1,598.9c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S913.5,598.9,914.1,598.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M918.8,631.8c0.6,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2S918.1,631.8,918.8,631.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M929.4,638.8c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S928.7,638.8,929.4,638.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M912.9,644.7c0.6,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2S912.3,644.7,912.9,644.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M902.4,636.5c0.7,0,1.2-0.5,1.2-1.2s-0.5-1.2-1.2-1.2s-1.2,0.5-1.2,1.2S901.7,636.5,902.4,636.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M901.2,657.6c0.6,0,1.2-0.5,1.2-1.2c0-0.6-0.5-1.2-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2 C900,657.1,900.5,657.6,901.2,657.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M904.6,578.5c1.7-0.1,3.3-0.9,4.5-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M304.3,359.7H202.8v114h101.5V359.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M290.7,372.8h-74.4v87.7h74.4V372.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M307.3,359.6h-2.9v114h2.9V359.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M268.4,390.7h-29.8v51.9h29.8V390.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M268.6,427.6c6.2,0,11.2-5,11.2-11.2c0-6.2-5-11.2-11.2-11.2c-6.2,0-11.2,5-11.2,11.2 C257.4,422.6,262.4,427.6,268.6,427.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M738.3,654.8l48.9,311.1h6.3l-38.9-311.1H738.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469.9,654.8l-39,311.1h6.3l48.9-311.1H469.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M793.5,965.9h-2.8l-41.9-301.3c-0.1-1.2-0.6-2.3-1.5-3.1c-0.9-0.8-2-1.3-3.1-1.4l-5.3-0.6l-0.6-4.8h16.3 L793.5,965.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M435,965.9L478.6,665c0.1-1.2-0.2-2.5-0.9-3.5c-0.7-1-1.8-1.7-3-2l-5.2-1l0.4-3.8h16.2l-48.8,311.1L435,965.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M516.2,965.9h6.5l48.9-311.1h-16.3L516.2,965.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M520.3,965.9l15.8-123l-5.8-3.9l24.9-184.2h16.3l-48.9,311.1H520.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M478,648.5c0,0.8,0.2,1.7,0.5,2.4c0.3,0.8,0.8,1.4,1.5,2c1.3,1.2,3.1,1.9,4.9,1.9h372.7 c1.6-0.2,3.1-0.9,4.3-2.1c1.1-1.1,1.7-2.6,1.7-4.1c0-1.5-0.6-3-1.7-4.1c-1.1-1.2-2.6-1.9-4.3-2.1H484.9c-0.9,0-1.8,0.2-2.6,0.5 c-0.8,0.3-1.6,0.8-2.2,1.3c-0.6,0.6-1.1,1.2-1.5,2C478.2,646.9,478,647.7,478,648.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M478,648.5c0,0.8,0.2,1.7,0.5,2.4c0.3,0.8,0.8,1.4,1.5,2c1.3,1.2,3.1,1.9,4.9,1.9h372.7 c1.6-0.2,3.1-0.9,4.3-2.1c1.1-1.1,1.7-2.6,1.7-4.1c0-1.5-0.6-3-1.7-4.1c-1.1-1.2-2.6-1.9-4.3-2.1H484.9c-0.9,0-1.8,0.2-2.6,0.5 c-0.8,0.3-1.6,0.8-2.2,1.3c-0.6,0.6-1.1,1.2-1.5,2C478.2,646.9,478,647.7,478,648.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.8,648.5c0,0.8,0.2,1.6,0.5,2.4c0.3,0.8,0.8,1.4,1.4,2c1.2,1.2,2.9,1.9,4.6,1.9h279.2c1.5-0.2,3-1,4-2.1 c1-1.1,1.6-2.6,1.6-4.1s-0.6-3-1.6-4.1c-1-1.1-2.5-1.9-4-2.1H430.3c-1.7,0-3.3,0.6-4.6,1.8c-0.6,0.6-1.1,1.2-1.4,2 C424,646.9,423.8,647.7,423.8,648.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M596.7,595.8l13.4-66l-0.4-0.1l-13.4,66L596.7,595.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M592.9,507.6l-0.4,0l1.8,85.8l0.4,0L592.9,507.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M573.3,523.4l-0.3,0.3l20.5,25.7l0.3-0.3L573.3,523.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M582.4,609.9l3.4-3c3.5-3,5.2-6.7,5.2-10.3v-7.3h13.2v7.3c0,3.7,1.8,7.3,5.2,10.3l3.4,3 c7.1,6.4,9.4,14.4,6.2,21.8l-3.8,9h-35.2l-3.8-9C573.1,624.3,575.4,616.3,582.4,609.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M581.5,609.9l3.1-3c3.1-3,7-6.7,7-10.3v-7.3h3.4v6.7c0,4.1-1.8,8.1-5.1,11.6c-5.1,6.3-5.1,13.6-3.3,19.5 c1.2,3.7,3.3,7.1,6,9.9l2.3,2.5c0.5,0.5,1.1,0.9,1.8,1.1c0.7,0.3,1.4,0.4,2.1,0.3h-19.5l-3.4-9 C573.2,624.3,575.3,616.3,581.5,609.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M577.5,549.9l-0.3,0.3l24.3,20.2l0.3-0.3L577.5,549.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M598.6,586l21.5-20.4l-0.2-0.2l-21.5,20.3L598.6,586z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M585.3,538.8L582,524c-0.3-1.2-0.9-2.3-1.7-3.3c-0.8-0.9-1.9-1.6-3.1-2c-1.2-0.4-2.4-0.5-3.7-0.3 c-1.2,0.2-2.4,0.7-3.4,1.5l0,0c-1,0.8-1.7,1.8-2.2,2.9c-0.5,1.1-0.6,2.4-0.5,3.6c0.1,1.2,0.6,2.4,1.3,3.4c0.7,1,1.7,1.8,2.8,2.4 L585.3,538.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M585.3,538.8L582,524c-0.3-1.2-0.9-2.3-1.7-3.3c-0.8-0.9-1.9-1.6-3.1-2c-1.2-0.4-2.4-0.5-3.7-0.3 c-1.2,0.2-2.4,0.7-3.4,1.5l0,0c-1,0.8-1.7,1.8-2.2,2.9c-0.5,1.1-0.6,2.4-0.5,3.6c0.1,1.2,0.6,2.4,1.3,3.4c0.7,1,1.7,1.8,2.8,2.4 L585.3,538.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M567.5,525.7c0,1.4,0.4,2.7,1.1,3.9c0.7,1.2,1.8,2.1,3,2.6l13.7,6.6l-15.1-18.9c-0.9,0.7-1.6,1.5-2.1,2.6 C567.7,523.5,567.5,524.6,567.5,525.7L567.5,525.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M593.1,532.2l9.7-20c0.8-1.6,1.2-3.5,1.1-5.3s-0.7-3.6-1.6-5.1c-1-1.5-2.3-2.8-3.9-3.7 c-1.6-0.9-3.4-1.3-5.2-1.3l0,0c-1.8,0-3.6,0.5-5.2,1.4s-2.9,2.2-3.9,3.7c-1,1.5-1.5,3.3-1.6,5.1c-0.1,1.8,0.3,3.6,1,5.3 L593.1,532.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M593.1,532.2l9.7-20c0.8-1.6,1.2-3.5,1.1-5.3s-0.7-3.6-1.6-5.1c-1-1.5-2.3-2.8-3.9-3.7 c-1.6-0.9-3.4-1.3-5.2-1.3l0,0c-1.8,0-3.6,0.5-5.2,1.4s-2.9,2.2-3.9,3.7c-1,1.5-1.5,3.3-1.6,5.1c-0.1,1.8,0.3,3.6,1,5.3 L593.1,532.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M592.6,496.8l0.5,35.4l-9.7-20c-0.8-1.6-1.2-3.4-1.1-5.2c0.1-1.8,0.6-3.5,1.5-5c0.9-1.5,2.2-2.8,3.7-3.7 C589.1,497.4,590.8,496.9,592.6,496.8L592.6,496.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M603.9,558.9l14-16.8c1.2-1.4,1.9-3,2.3-4.8c0.3-1.8,0.2-3.6-0.3-5.3c-0.5-1.7-1.5-3.2-2.8-4.5 c-1.3-1.2-2.9-2.1-4.6-2.5l0,0c-1.7-0.4-3.6-0.4-5.3,0c-1.7,0.5-3.3,1.3-4.6,2.6c-1.3,1.2-2.3,2.8-2.8,4.5 c-0.5,1.7-0.6,3.5-0.3,5.3L603.9,558.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M599.5,537.5c-0.4-1.8-0.3-3.6,0.3-5.3c0.5-1.7,1.5-3.3,2.8-4.5c1.3-1.2,2.9-2.1,4.6-2.6 c1.7-0.5,3.6-0.5,5.3,0l-8.6,33.8L599.5,537.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M605.9,578.9l6.4-16c0.5-1.3,1.4-2.5,2.5-3.4c1.1-0.9,2.4-1.5,3.8-1.8c1.4-0.3,2.8-0.2,4.2,0.3 c1.3,0.4,2.5,1.2,3.5,2.3c1,1,1.6,2.3,2,3.7c0.3,1.4,0.3,2.8-0.1,4.2c-0.4,1.4-1.1,2.6-2.1,3.6c-1,1-2.2,1.7-3.6,2.2L605.9,578.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M605.9,578.9l6.4-16c0.5-1.3,1.4-2.5,2.5-3.4c1.1-0.9,2.4-1.5,3.8-1.8c1.4-0.3,2.8-0.2,4.2,0.3 c1.3,0.4,2.5,1.2,3.5,2.3c1,1,1.6,2.3,2,3.7c0.3,1.4,0.3,2.8-0.1,4.2c-0.4,1.4-1.1,2.6-2.1,3.6c-1,1-2.2,1.7-3.6,2.2L605.9,578.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M625.9,560l-20,18.9l6.4-16c0.5-1.3,1.3-2.4,2.4-3.3c1.1-0.9,2.3-1.5,3.6-1.8c1.3-0.3,2.7-0.2,4,0.1 C623.7,558.3,624.9,559,625.9,560L625.9,560z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M595.2,564.8l-7-16.9c-0.6-1.4-1.5-2.6-2.7-3.5c-1.2-0.9-2.6-1.6-4-1.8c-1.5-0.3-3-0.1-4.4,0.4 c-1.4,0.5-2.7,1.3-3.7,2.4c-1,1.1-1.7,2.5-2,3.9c-0.3,1.5-0.3,3,0.1,4.4c0.4,1.4,1.2,2.7,2.3,3.8c1.1,1.1,2.4,1.8,3.8,2.2 L595.2,564.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M595.2,564.8l-7-16.9c-0.6-1.4-1.5-2.6-2.7-3.5c-1.2-0.9-2.6-1.6-4-1.8c-1.5-0.3-3-0.1-4.4,0.4 c-1.4,0.5-2.7,1.3-3.7,2.4c-1,1.1-1.7,2.5-2,3.9c-0.3,1.5-0.3,3,0.1,4.4c0.4,1.4,1.2,2.7,2.3,3.8c1.1,1.1,2.4,1.8,3.8,2.2 L595.2,564.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M594.4,585.6l0.2-0.3L561.3,567l-0.2,0.3L594.4,585.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M589,582.4L577,565.9c-1-1.4-2.3-2.4-3.8-3.1c-1.5-0.7-3.2-1-4.9-0.9c-1.7,0.1-3.3,0.7-4.7,1.6 c-1.4,0.9-2.6,2.2-3.3,3.6l0,0c-0.8,1.5-1.2,3.1-1.2,4.8c0,1.7,0.5,3.3,1.3,4.8c0.8,1.5,2,2.7,3.4,3.5c1.4,0.9,3.1,1.4,4.7,1.4 L589,582.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M589,582.4L577,565.9c-1-1.4-2.3-2.4-3.8-3.1c-1.5-0.7-3.2-1-4.9-0.9c-1.7,0.1-3.3,0.7-4.7,1.6 c-1.4,0.9-2.6,2.2-3.3,3.6l0,0c-0.8,1.5-1.2,3.1-1.2,4.8c0,1.7,0.5,3.3,1.3,4.8c0.8,1.5,2,2.7,3.4,3.5c1.4,0.9,3.1,1.4,4.7,1.4 L589,582.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M560,575.7c0.8,1.7,2,3.1,3.5,4.2c1.5,1,3.3,1.6,5.2,1.7l20.5,0.8L560.3,567c-0.7,1.3-1.1,2.8-1.2,4.3 C559.1,572.8,559.4,574.3,560,575.7L560,575.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M588.2,547.9l7,16.9l-21.8-19.5c1-1.1,2.3-1.9,3.7-2.4c1.4-0.5,2.9-0.6,4.4-0.3c1.5,0.3,2.8,0.9,4,1.8 C586.7,545.3,587.6,546.5,588.2,547.9L588.2,547.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M728.7,636.5l-40.9-100.3c-0.4-0.9-1.1-1.6-1.9-2s-1.9-0.4-2.8,0L681,535l43.9,107.7l1.3-0.5v0.2h110.4 c1.6,0,3-0.6,4.2-1.7c1.1-1.1,1.7-2.6,1.7-4.2L728.7,636.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M728.7,636.5l-40.9-100.3c-0.4-0.9-1.1-1.6-1.9-2s-1.9-0.4-2.8,0L681,535l43.9,107.7l1.3-0.5v0.2h110.4 c1.6,0,3-0.6,4.2-1.7c1.1-1.1,1.7-2.6,1.7-4.2L728.7,636.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1215.8,906.7c0,0,8.8-70.2,29-108.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1200.9,786c0,0,13.7,56.6,11.5,95.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1242.9,801.6c0,0,0.2-37.9,33.3-40.1C1276.2,761.3,1278.9,794.7,1242.9,801.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1163.4,793.4c0,0-8.9-36.1-48.2-25.8C1115.3,767.5,1122.8,793.9,1163.4,793.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1206,808.2c0,0,11.7-30.7-15.4-46.7C1190.5,761.3,1178.5,791.6,1206,808.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1163.4,793.4c0,0,36,41.2,36,113.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1226.9,787.7c-7.9,31.7-11.4,38.6-16,119"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1133.6,743.7c15.9,7.2,65.9,59.7,57.5,161.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1185.1,905.4c0,0,10.4-70.7-33.3-94.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1217.2,896c0,0,3.8-11.2,15.9-20.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1221.1,874.1c0,0,24.7-21.8,37.1-25.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1171.4,829.1c0,0-9.7-37.1-48.3-28.4C1123,800.7,1129.7,832.3,1171.4,829.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1171.4,829.1c0,0-9.7-37.1-48.3-28.4C1123,800.7,1129.7,832.3,1171.4,829.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1191.1,867.2c0,0-6.6-26.4-42-17.6C1149.3,849.5,1160.8,875.8,1191.1,867.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1215.2,850c0,0,3.3-41.4,46.4-46.5C1261.5,803.6,1263.6,844.1,1215.2,850"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1205.2,724c0,0-1.7,153-2,182.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1211.6,839.1c0,0-36.8,1.9-36.8-38.8C1174.8,800.3,1210.5,800.7,1211.6,839.1z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1211.6,839.1c0,0-36.8,1.9-36.8-38.8C1174.8,800.3,1210.5,800.7,1211.6,839.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1246.5,854.8c0,0,9.9-28,41.7-20.9C1288,833.9,1282.8,857.5,1246.5,854.8z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1246.5,854.8c0,0,9.9-28,41.7-20.9C1288,833.9,1282.8,857.5,1246.5,854.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1231.8,906h-65.2v8.2h65.2V906z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1223.6,967.6h-48.8l-3.6-53.5h56L1223.6,967.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M1223.6,967.6h-48.8l-3.6-53.5h56L1223.6,967.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1231.8,906h-10.5v8.1h-9.8h-40.2l0.1,2.3h40.1l0.2,51.2h12l3.6-53.5h4.6V906z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1204.8,755.6c0,0-18-27.2,5.5-53.4C1210.1,702.2,1225.7,728.8,1204.8,755.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1204.8,755.6c0,0-18-27.2,5.5-53.4C1210.1,702.2,1225.7,728.8,1204.8,755.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1221.1,810.4c0,0-19.8-42.3,15.6-68.2C1236.7,742.2,1261.1,780.4,1221.1,810.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1221.1,810.4c0,0-19.8-42.3,15.6-68.2C1236.7,742.2,1261.1,780.4,1221.1,810.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1225.9,882.6c0,0,4.8-18.5,30-14.6C1255.9,868.1,1251.7,886.8,1225.9,882.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1191.5,891c0,0-5.5-35.6,27.1-39.8C1218.7,851.2,1226.4,882.2,1191.5,891z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1191.5,891c0,0-5.5-35.6,27.1-39.8C1218.7,851.2,1226.4,882.2,1191.5,891z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1124.6,738.3c0,0,19.6-2,23.4,16.9C1148.1,755,1130.4,757.1,1124.6,738.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1124.6,738.3c0,0,19.6-2,23.4,16.9C1148.1,755,1130.4,757.1,1124.6,738.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1172.5,736.2c0,0-24.4,25.4-0.6,53.1C1171.9,789.3,1196,762.2,1172.5,736.2z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M1172.5,736.2c0,0-24.4,25.4-0.6,53.1C1171.9,789.3,1196,762.2,1172.5,736.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M322.2,719.6h-270V879h270V719.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M315.8,871.5H58.4V728h257.4V871.5z M60.1,869.4h254V730.2h-254V869.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M388.2,719.6h-65.9V879h65.9V719.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M388.2,719.6h-65.9V879h65.9V719.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M59.3,775.2H315c0.4,0,0.4-2.4,0-2.4H59.3C58.8,772.8,58.8,775.2,59.3,775.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M196.5,728.9v45.6c0,0.6-2.1,0.5-2.1,0V729L196.5,728.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M59.3,824H315c0.4,0,0.4-2.4,0-2.4H59.3C58.8,821.6,58.8,824,59.3,824z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M260.3,750.4c0,2.5-1.7,4.5-3.9,4.5s-3.9-2-3.9-4.5s1.7-4.5,3.9-4.5S260.3,747.9,260.3,750.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M130.2,750.4c0,2.5-1.7,4.5-3.9,4.5c-2.2,0-3.9-2-3.9-4.5s1.7-4.5,3.9-4.5 C128.5,745.9,130.2,747.9,130.2,750.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M200.4,799.8c0,2.5-1.7,4.5-3.9,4.5s-3.9-2-3.9-4.5c-0.1-0.6,0-1.1,0.1-1.7c0.2-0.5,0.4-1,0.8-1.5 c0.4-0.4,0.8-0.8,1.3-1s1.1-0.4,1.6-0.4c0.6,0,1.1,0.1,1.6,0.4c0.5,0.2,1,0.6,1.3,1c0.4,0.4,0.6,0.9,0.8,1.5 C200.4,798.7,200.5,799.2,200.4,799.8L200.4,799.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M77.7,879l-15.4,86.6H71L99.4,879H77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M140.5,879l-15.4,86.6h8.7l28.4-86.6H140.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M299.3,879l12.9,86.8h-8.7L277.6,879H299.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M369.5,879l14.6,86.8h-8.7L347.8,879H369.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M200.1,844.9c0,2.5-1.7,4.5-3.9,4.5c-2.1,0-3.9-2-3.9-4.5s1.7-4.5,3.9-4.5 C198.4,840.4,200.1,842.4,200.1,844.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.9,894.2l8.3,2.4l-16.1,69h3.8l28.8-86.5H78.1L74.9,894.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.7,914.9l7.3,5.4l-11.7,45.3h3.5l28.8-86.5H141L134.7,914.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M358.2,911.8l10.4,2.4l11.8,51.6l3.6-0.1l-14.4-86.5H348L358.2,911.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.9,893.2l12.5,2.4l14.3,70.2l3.2-0.1l-12.4-86.5h-21.6L281.9,893.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M422.5,945.6l61.5,1.5l-24.5-17.6c-2-1.4-3.7-3.3-4.9-5.5c-1.2-2.2-1.9-4.6-2-7.1l-0.8-19.3l-33.5,0.1 L422.5,945.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M429.3,923.2v-0.4c-0.1-0.5,0-1,0.1-1.5c0.1-0.5,0.4-1,0.7-1.4c0.3-0.4,0.7-0.7,1.2-1c0.5-0.3,1-0.4,1.5-0.5 l19.6-2.8l-0.2-3.9h-32.8l2.9,32.6l26.8-2.9l-8.9-3.6c-3-1.2-5.6-3.2-7.5-5.8C430.7,929.4,429.6,926.4,429.3,923.2L429.3,923.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M311.6,944.4h27.6l5.1-46.9l-32.8,0.1L311.6,944.4L311.6,944.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M318.4,936.6l0.7-14.4c0-0.9,0.4-1.8,1-2.5c0.6-0.7,1.5-1.1,2.4-1.2l19.9-3.1l0.5-4l-31.2,0.1l-0.1,33.2 L318.4,936.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.8,534.9v383h36l31.3-312.3c0.1-1,0.5-1.9,1.3-2.6c0.7-0.7,1.7-1,2.7-1c1,0,1.9,0.4,2.6,1 c0.7,0.7,1.2,1.5,1.3,2.5l33.2,312.3h36L441.8,537L309.8,534.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M313.6,928l0.8-0.8c3.2-3.1,7.5-4.8,12-4.8c4.5,0,8.7,1.9,11.9,5l0.5,0.6c1.6,1.6,2.5,3.8,2.5,6v3.5 c0,2.1,0.3,4.2,0.9,6.1l2.9,9.8c0.8,2.4,1.2,4.8,1.2,7.3v1.2c0,0.9-0.4,1.8-1.1,2.5c-0.7,0.6-1.6,1-2.5,1h-34 c-0.5,0-0.9-0.1-1.4-0.2c-0.4-0.2-0.8-0.4-1.2-0.7c-0.3-0.3-0.6-0.7-0.8-1.1c-0.2-0.4-0.3-0.9-0.3-1.4v-0.5c0-2.9,0.5-5.8,1.4-8.5 l3.4-9.6c0.7-2.2,1.1-4.5,1.2-6.8l0.1-2.7C311.2,931.7,312.1,929.6,313.6,928L313.6,928z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.8,917.9h38.3l0.7-7.8h-38.9L308.8,917.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M308.8,917.9h38.3l0.7-7.8h-38.9L308.8,917.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.8,917.9h16.1l0.4-7.7h-16.3L308.8,917.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.8,961.6v0.5c0,0.9,0.4,1.8,1.1,2.5c0.7,0.6,1.6,1,2.5,1h34c0.5,0,0.9-0.1,1.4-0.2c0.4-0.2,0.8-0.4,1.2-0.7 c0.3-0.3,0.6-0.7,0.8-1.1c0.2-0.4,0.3-0.9,0.3-1.4v-1.2c0-0.5,0-1-0.1-1.4h-41.3C304.7,960.2,304.8,960.9,304.8,961.6L304.8,961.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M418.2,934.7v24c0,0.9,0.2,1.8,0.5,2.7c0.3,0.8,0.9,1.6,1.5,2.3c0.6,0.7,1.4,1.2,2.3,1.5 c0.8,0.3,1.8,0.5,2.7,0.5h81.5c0.4,0,0.8-0.1,1.1-0.2c0.4-0.1,0.7-0.4,1-0.6c0.3-0.3,0.5-0.6,0.6-1c0.1-0.4,0.2-0.7,0.2-1.1 c0-2.8-0.9-5.5-2.5-7.8c-1.6-2.3-3.9-4-6.6-4.9l-18.3-6l-23.4-18c-1.2-0.9-2.6-1.4-4.1-1.3c-1.5,0-2.9,0.6-4,1.6l-10.4,8.9 c-0.8,0.6-1.7,1.1-2.6,1.3c-1,0.2-2,0.2-2.9-0.1l-13.1-4.1c-0.4-0.2-0.8-0.2-1.3-0.1c-0.4,0.1-0.8,0.2-1.2,0.5 c-0.3,0.3-0.6,0.6-0.8,1C418.3,933.9,418.2,934.3,418.2,934.7L418.2,934.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.2,965.6h81.5c0.4,0,0.8-0.1,1.1-0.2c0.4-0.1,0.7-0.4,1-0.6c0.3-0.3,0.5-0.6,0.6-1c0.1-0.4,0.2-0.7,0.2-1.1 c0-1-0.1-2-0.3-3h-91c0.2,1.7,1,3.2,2.3,4.3C421.9,965.1,423.5,965.7,425.2,965.6L425.2,965.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M458.3,935.5c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5 l5-5.3c0.2-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.2,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5l-5,5.3 C458.8,935.5,458.6,935.5,458.3,935.5L458.3,935.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M462.2,938.6c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5 l5-5.3c0.2-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.2,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5l-5,5.3 C462.7,938.5,462.5,938.6,462.2,938.6L462.2,938.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M466.1,941.6c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.2c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.2,0.1-0.4,0.2-0.5 l5-5.3c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.2,0.3 c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.2l-5,5.3C466.6,941.6,466.5,941.6,466.1,941.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M332.6,936c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-2-0.9-4.1-1.4-6.3-1.4c-2.2,0-4.3,0.5-6.3,1.4 c-0.2,0.1-0.4,0.1-0.7,0.1c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.1-0.4-0.1-0.7c0.1-0.2,0.2-0.4,0.4-0.5c2.2-1.1,4.6-1.6,7.1-1.6 c2.5,0,4.9,0.6,7.1,1.6c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0,0.5-0.1,0.7c-0.1,0.1-0.2,0.3-0.3,0.3C332.9,936,332.8,936,332.6,936 L332.6,936z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M332.6,940.4c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-2-0.9-4.1-1.4-6.3-1.4c-2.2,0-4.3,0.5-6.3,1.4 c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c2.2-1.1,4.6-1.6,7.1-1.6c2.5,0,4.9,0.6,7.1,1.6 c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0,0.5-0.1,0.7c-0.1,0.1-0.2,0.3-0.3,0.3C332.9,940.3,332.8,940.4,332.6,940.4L332.6,940.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M332.6,944.6c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-2-0.9-4.1-1.4-6.3-1.4c-2.2,0-4.3,0.5-6.3,1.4 c-0.2,0.1-0.4,0.1-0.6,0c-0.2-0.1-0.4-0.2-0.5-0.4c-0.1-0.2-0.1-0.4-0.1-0.6c0.1-0.2,0.2-0.4,0.4-0.5c2.2-1.1,4.6-1.6,7.1-1.6 c2.5,0,4.9,0.6,7.1,1.6c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0,0.5-0.1,0.7c-0.1,0.1-0.2,0.3-0.3,0.3S332.8,944.6,332.6,944.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.1,913.7l-34.9-295c-0.6-4.6-2.8-8.8-6.2-11.8c-3.4-3.1-7.9-4.8-12.5-4.8H381c1,0,1.9,0.4,2.6,1 s1.2,1.5,1.3,2.5l33,310.6L439.1,913.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M417.3,917.9h38.1l-0.5-7.8h-38.5L417.3,917.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M417.3,917.9h38.1l-0.5-7.8h-38.5L417.3,917.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M417.3,917.9h22.4l-1.1-7.8h-22.2L417.3,917.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M309.8,537.7v372.2l15.4,0.1l14.3-372.3H309.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M406,388.5l-90.4,27.2l-8.5,76.7l2.6,57.4h132l3.1-89l0.2,0.2L406,388.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M459.1,486.4l4.7,1.4c16.3,4.1,30.9-11.3,26.1-27.4l-27.7-95.7c-1.3-4.4-3.9-8.3-7.3-11.3 c-3.5-3-7.7-5-12.3-5.7l-50.3-8.3l-47.3,0.2c0,0-3-0.2-46.7,13.1c-5.9,1.8-11.1,5.6-14.5,10.8c-3.4,5.2-5,11.4-4.4,17.5l8.5,86.4 c0.3,2.9,1.2,5.6,2.6,8.1c1.4,2.5,3.3,4.7,5.5,6.5c2.3,1.8,4.8,3.1,7.6,3.9c2.8,0.8,5.7,1,8.5,0.6l34.6-4.4v-32h-9.3l-1.8-47.5 l0.8,23.2l118.1,22.4L459.1,486.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M370.3,359.4c0,0,20.1,1.3,26.2-19.3l-4.3-0.7l-47.3,0.2c-1.6,0.2-3.1,0.5-4.6,1 C340.2,340.6,345.8,359.4,370.3,359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M456.5,447.8l-17.4-3.3l-6.3-22.3l43.8-8.6l13.4,46.9c4.8,16-9.8,31.5-26.1,27.4l-4.2-1.3L456.5,447.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M327.9,446.2l-2.9-49.5c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0,0.4,0.1 c0.1,0.1,0.2,0.2,0.3,0.4l11.1,53.8l-9,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M326.4,422.2l1.9,30.3l17.6-2l1.4-23.5l-5.4-1.1l-2.6-1.9c-1.7-1.3-6.4-1.3-7.8-1.5L326.4,422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M439.3,445.5l-15.1-53.1c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.3l0.6,49.6 L439.3,445.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M389.6,307.3c0,2.5-0.3,5-0.8,7.4l2.7,24.7c0.1,0.8,0,1.6-0.3,2.3c-0.3,0.7-0.8,1.4-1.4,1.8l-17.7,2.4 c-0.3,0.3-0.7,0.4-1.1,0.5c-0.4,0-0.8,0-1.2-0.2l-22.8-2.6c-0.6-0.4-1.2-1-1.5-1.6c-0.4-0.7-0.6-1.4-0.6-2.2l2.8-41.6l0.6-8.3 c1.4-31.7,42.9-5.8,42.9-5.8S390,295.1,389.6,307.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.7,285.9c-2.8,0-5.5-0.8-7.8-2.4c-2.3-1.5-4.1-3.7-5.2-6.3c-1.1-2.6-1.3-5.4-0.8-8.1c0.5-2.7,1.9-5.2,3.8-7.2 c2-2,4.5-3.3,7.2-3.9c2.7-0.5,5.6-0.3,8.1,0.8c2.6,1.1,4.8,2.9,6.3,5.2c1.5,2.3,2.4,5,2.4,7.8c0,1.8-0.4,3.7-1.1,5.4 c-0.7,1.7-1.7,3.3-3,4.6c-1.3,1.3-2.9,2.3-4.6,3C398.4,285.6,396.6,285.9,394.7,285.9L394.7,285.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M349.7,260.8l-1.3,27.6c0,0,3.1,42.6,30.5,39c31.5-4.1,16.9-65.7,16.9-65.7L349.7,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2,242.6c-4.7-2.8-8.9-3.3-11.7-2.1c-0.9,0.4-2,0.5-3,0.2c-1-0.3-1.8-1-2.3-1.8c-1.9-2.8-5.5-5.3-12.4-5.6 c-8.9-0.3-12.7,4.5-14.4,7.2c-0.3,0.6-0.7,1-1.3,1.4c-0.5,0.4-1.1,0.6-1.8,0.6c-4.1,0.6-12.5,3.7-15.4,12.2 c-5.1,14.9,5.5,31.3,5.5,31.3l6.6-4.1l1.2,1.9l1.2,5.8c0,0.6,0.8,1.1,1.4,1.1c0.2,0,0.3-0.1,0.5-0.1c0.2-0.1,0.3-0.2,0.4-0.3 c0.1-0.1,0.2-0.3,0.2-0.4c0.1-0.2,0.1-0.3,0-0.5l-0.3-6.1c0-0.2,0-0.5,0.1-0.7c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.2,0.3-0.3,0.6-0.4 c0.2-0.1,0.4-0.2,0.7-0.2c0.8-0.1,1.6-0.3,2.4-0.7c0.7-0.4,1.4-0.9,1.9-1.5c0.5-0.6,0.9-1.4,1.2-2.2c0.2-0.8,0.3-1.6,0.3-2.5 c-0.1-0.8,0-1.7,0.2-2.5c0.2-0.8,0.7-1.5,1.2-2.2c0.5-0.6,1.2-1.2,2-1.5c0.7-0.4,1.6-0.6,2.4-0.6l28-2 C403.6,263.9,407.2,248.2,398.2,242.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M347.1,305.9l4.5-6.8c-1.2,0.8-2.7,1.1-4.1,1.1L347.1,305.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M351,292.3c1.1,4.7,2.2,8.3-3.9,7.8c-11.7-0.8-13-16.5-6.1-19.6c0.7-0.4,1.5-0.7,2.3-0.7 c0.8-0.1,1.6,0.1,2.4,0.4c0.8,0.3,1.5,0.8,2,1.3c0.6,0.6,1,1.3,1.3,2.1L351,292.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M450.9,417.3l2.7-0.2c0.5-0.1,1.1,0,1.5,0.3c0.5,0.2,0.9,0.6,1.2,1l0,0c0.4,0.6,0.5,1.2,0.5,1.9 c-0.1,0.7-0.4,1.3-0.8,1.8l0,0c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.2-0.2,0.5-0.1,0.8c0,0.4,0.1,0.8,0.4,1.2c0.2,0.3,0.6,0.6,1,0.7 l0.6,0.2c0.5,0.2,0.9,0.4,1.2,0.8c0.3,0.3,0.6,0.8,0.8,1.2v0.1c0.2,0.6,0.2,1.1,0.1,1.7c-0.1,0.6-0.4,1.1-0.8,1.5 c-0.6,0.6-1.4,0.9-2.2,0.9h-1.6c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2 c0.3,0.5,0.4,1.1,0.3,1.7c-0.1,0.6-0.4,1.1-0.8,1.6l0,0c-0.5,0.5-1.3,0.8-2,0.8h-5.7l0.8,0.8c0.2,0.2,0.4,0.4,0.5,0.7l0.1,0.3 c0.2,0.5,0.3,1,0.2,1.6c-0.1,0.5-0.3,1-0.7,1.4c-0.3,0.3-0.7,0.5-1.1,0.6c-0.4,0.1-0.8,0.1-1.3,0.1l-10.1-2.1l0.4-18.3 L450.9,417.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340.3,285.9c0.2,0.4,0.6,0.4,1.1,0.2c0.3-0.3,0.7-0.5,1-0.6c0.4-0.1,0.8-0.1,1.2,0c0.6,0,1.1,0.6,1.7,1.4 c0.7,1.1,1,2.3,1.1,3.5l0.2,1.4c0,0.4,0.3,0.6,0.8,0.6s0.6-0.3,0.6-0.8l-0.2-1.4c-0.1-1.5-0.5-3-1.2-4.4c-0.6-1-1.6-1.7-2.7-2 c-1.2-0.2-2.4,0.1-3.3,0.8C340.3,284.9,340.2,285.2,340.3,285.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M373.7,328.9c-5.6-0.8-10.8-3.5-14.6-7.7c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2 c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0s0.2,0,0.2,0c0.1,0,0.1,0.1,0.2,0.1c3,3.3,6.8,5.6,11.1,6.8 c8.5,1.9,16.1-2,18.8-4.7l1.1,9.9c-2.9,0.6-6,0.6-8.9,0C379,331.7,376.2,330.6,373.7,328.9L373.7,328.9z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385.6,311.9c0-0.6-0.6-0.9-1.6-1c-4.9-0.1-7.2-0.3-7.2-0.3c-0.7-0.1-1.7,0.2-1.7,0.7c0,0.5,0.6,0.9,1.6,1 c0.3,1.7,1.7,3.1,3.3,3.3c1.9,0.3,3.9-1,4.4-3C384.8,312.4,385.2,312.1,385.6,311.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M376.2,294c-0.5,0-1-0.1-1.4-0.4c-0.4-0.3-0.7-0.7-0.9-1.1c-0.2-0.5-0.2-1-0.1-1.4c0.1-0.5,0.3-0.9,0.7-1.3 c0.3-0.3,0.8-0.6,1.3-0.7c0.5-0.1,1,0,1.4,0.1c0.5,0.2,0.8,0.5,1.1,0.9c0.3,0.4,0.4,0.9,0.4,1.4c0,0.3-0.1,0.7-0.2,1 c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.8,0.5S376.5,294.1,376.2,294L376.2,294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M377.2,292.5c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.2 c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0.1 c0.1,0,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2s-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1 S377.3,292.5,377.2,292.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.1,294c-0.5,0-1-0.1-1.4-0.4c-0.4-0.3-0.7-0.7-0.9-1.1c-0.2-0.5-0.2-1-0.1-1.4c0.1-0.5,0.3-0.9,0.7-1.3 c0.3-0.3,0.8-0.6,1.3-0.7c0.5-0.1,1,0,1.4,0.1c0.5,0.2,0.8,0.5,1.1,0.9c0.3,0.4,0.4,0.9,0.4,1.4c0,0.3,0,0.7-0.2,1 c-0.1,0.3-0.3,0.6-0.5,0.8c-0.2,0.2-0.5,0.4-0.8,0.5C393.7,294,393.4,294.1,393.1,294L393.1,294z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M394.1,292.5c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.2 c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0,0.1,0,0.2,0,0.2 c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1C394.3,292.5,394.2,292.5,394.1,292.5L394.1,292.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M387,301.8c-0.1-0.8-0.5-1.5-1.1-2c-0.6-0.5-1.4-0.8-2.2-0.7c-0.4,0-0.6,0.3-0.6,0.8c0,0.5,0.4,0.6,0.8,0.6 c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.4,0.2,0.5,0.3c0.2,0.1,0.3,0.3,0.4,0.5c0.1,0.2,0.1,0.4,0.2,0.6c0,0.2,0,0.4-0.1,0.6 c-0.1,0.2-0.2,0.4-0.3,0.5c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0.1-0.6,0.2l-3.3,0.2c-0.4,0-0.6,0.3-0.6,0.8 c0,0.5,0.3,0.6,0.8,0.6l3.3-0.2c0.4,0,0.8-0.1,1.1-0.3c0.3-0.2,0.6-0.4,0.9-0.7c0.2-0.3,0.4-0.6,0.5-1 C387,302.5,387.1,302.1,387,301.8L387,301.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M405.1,436.7l6.3,19l4.3-2.1c16.7,0.2,19.2-13.5,19.2-13.5l10,0.9c0.4,0,0.8-0.1,1.1-0.4 c0.3-0.3,0.5-0.6,0.6-1c0-0.4,0-0.8-0.3-1.2c-0.2-0.4-0.5-0.6-0.9-0.8l-8-2.5l13.1-0.4c0.6,0,1.1-0.2,1.5-0.6 c0.4-0.4,0.7-0.9,0.7-1.5c0-0.3,0-0.6-0.1-0.8c-0.1-0.3-0.2-0.5-0.4-0.7c-0.2-0.2-0.4-0.4-0.7-0.5c-0.3-0.1-0.5-0.2-0.8-0.2 l4.8,0.3h0.1c0.4,0,0.8-0.1,1.2-0.3c0.4-0.2,0.6-0.5,0.8-0.9c0.2-0.3,0.3-0.7,0.3-1.1c0-0.4-0.1-0.8-0.2-1.1 c-0.2-0.3-0.4-0.6-0.7-0.9c-0.3-0.2-0.7-0.4-1-0.5l-20.2-2.7l16.7-1c0.6-0.1,1.1-0.3,1.5-0.8c0.4-0.4,0.6-1,0.6-1.6v-0.2 c0-0.3-0.1-0.6-0.2-0.9c-0.1-0.3-0.3-0.5-0.6-0.7c-0.2-0.2-0.5-0.3-0.8-0.4c-0.3-0.1-0.6-0.1-0.9-0.1h-16.7c-2.5,0-5,0.9-7,2.5 l-18.8,15.3L405.1,436.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M285.1,439l4.2,46.3c0.3,3,1.3,5.9,2.9,8.5c1.6,2.6,3.8,4.7,6.5,6.2c2.6,1.5,5.6,2.4,8.6,2.6 c3,0.2,6-0.4,8.8-1.6l99.2-43.4l-7.6-21.9l-79.7,16.7l-1.5-20.9L285.1,439z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M347.4,425.6l-0.2,1.3l91,17.4v-1.9L347.4,425.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M396.4,466.3l-2,1.3l49.5,14.7l-0.1-1.3L396.4,466.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M436.5,429.4l14.4,1.5v-1.2l-14.3-1.5L436.5,429.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M345.7,450.5l-2.2-1.1l121,38.6l-8-40.2l-109.4-20.9L345.7,450.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M328.3,452.7l-8.2,2h-0.2c-0.7,0-1.3-0.9-0.4-1.8l8.4-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M285.5,438.9l-6.3-57.7c-0.5-4.5,0.1-9,1.9-13.2c1.7-4.2,4.5-7.8,8.1-10.6c-2.1,4.4-2.9,9.3-2.5,14.2l7,65.8 L285.5,438.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M293.7,437.4l5.6,47.8c0.4,3.9,2,7.5,4.5,10.5c2.5,3,5.9,5.1,9.7,6.1c-2.7,0.7-5.5,0.8-8.2,0.4 c-2.7-0.5-5.3-1.5-7.6-3.1c-2.3-1.6-4.2-3.6-5.6-6c-1.4-2.4-2.3-5.1-2.6-7.8l-2-25.7l-1.9-20.5L293.7,437.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M308.1,502.5c1.8,0,3.7-0.2,5.4-0.7l15.6-6.6l67.3-28.9l-48.2,32c-2.2,1.3-4,3.1-5.3,5.3 c-1.3,2.2-2,4.6-2.2,7.1l-1.3,39.8h-29.7L308.1,502.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.4,283.4c-0.2,0.5-2.4,0.2-5,0.4c-2.6,0.2-4.7,0.7-5,0.3c-0.2-0.2,0.2-0.6,1.1-1.1c1.2-0.5,2.5-0.9,3.8-0.9 c1.3-0.1,2.6,0,3.9,0.4C379,282.8,379.5,283.2,379.4,283.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.6,283.2c0.3,0.4,2.4-0.4,5-0.8c2.5-0.4,4.7-0.4,5-0.9c0.1-0.2-0.4-0.6-1.3-0.8c-1.3-0.3-2.6-0.3-3.9,0 c-1.3,0.2-2.6,0.6-3.7,1.3C386.8,282.5,386.4,283,386.6,283.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M438.1,441.1c6.4,1.4,12.6,3.6,18.4,6.7l-17.4-3.3L438.1,441.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M326.8,422.6l4,15.4c0.6,2.2,1.9,4.1,3.8,5.4c1.9,1.3,4.2,1.8,6.4,1.5l3.1-0.4l96.4,28.7 c48.5,14.7,50.3-6.8,50.4-7.6c-0.7,25.1-26.8,23-26.8,23l-120.4-39.1l-15.2,3.1l-0.3-4.7L326.8,422.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M382.1,352c4.8-2.8,8.3-7.3,9.9-12.6l-47.1,0.2h-0.5c0.4,1,4.8,11.9,19.2,15 C369.9,356.1,376.5,355.2,382.1,352L382.1,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M376.8,356.6l-5.1,0.7l2.4,17.9l5.1-0.7L376.8,356.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M374.9,311.1l14.1,0.2c-0.3,1.6-1.1,2.9-2.3,4s-2.8,1.6-4.3,1.5C375.7,316.8,374.9,311.1,374.9,311.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilienrecht);
export default __webpack_public_path__ + "static/media/Familienrecht.48649d02124087507d26fec7c0314471.svg";
export { ForwardRef as ReactComponent };